module.exports = __webpack_public_path__ + "media/images/gallery/constellations/en_layer_on-e90b1b5c98ae34ccc6aa42e3af966d97.png";